import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { Button } from 'ui-components/components/button';
import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import { refreshTracking as refreshTrackingAction } from '../../store/shipments/grid/shipments.grid.header.actions';
import { BASE_ORDERS_PATH } from '../../routes/constants';

import style from './shared-classes.module.less';

const RefreshTrackingButton = () => {
  const dispatch = useDispatch();
  const isOrdersPage = useRouteMatch(BASE_ORDERS_PATH);
  const fulfillmentSelector = isOrdersPage ? Global.selectSelectedOrdersIds : Global.selectSelectedShipmentsSelectedShipmentIds;
  const fulfillmentIds = useSelector(fulfillmentSelector) || emptyArray;
  const oneOrMoreFulfillmentsSelected = fulfillmentIds.length > 0;
  const disabled = !oneOrMoreFulfillmentsSelected;
  // TODO: Update refresh tracking once backend route is in place. - Aaron Llanos https://auctane.atlassian.net/browse/SPD-7472
  const refreshTracking = useCallback(() => dispatch(refreshTrackingAction(fulfillmentIds)), [fulfillmentIds, dispatch]);

  return (
    <Button className={style['action-button']} disabled={disabled} onClick={refreshTracking} theme='tertiary'>
      <FormattedMessage defaultMessage='Update Tracking' description='gridHeader.refreshTracking' id='LNmdUs' />
    </Button>
  );
};

export default RefreshTrackingButton;
